import { queryOptions, useQuery } from "@tanstack/react-query";

import { adminApiRequest } from "~api/api-request";
import { ApiResponse } from "~api/api-response.model";
import { Company } from "./company.model";

export const companyQueries = {
  all: queryOptions({
    queryKey: ["companies"],
    queryFn: fetchCompanies,
  }),
};

// Queries

export function useCompaniesQuery() {
  return useQuery(companyQueries.all);
}

// Fetchers

export async function fetchCompanies() {
  return adminApiRequest
    .get<ApiResponse<Company[]>>("api/internal/companies", {
      params: { permission: "analytics" },
    })
    .then((resp) => resp.data.data.map((d) => new Company(d)));
}
